import Vue from 'vue';
import './assets/scss/main.scss';

import VueCarousel from 'vue-carousel';

Vue.use(VueCarousel);

Vue.config.productionTip = false;

// eslint-disable-next-line no-new
new Vue({
  el: '#RadioButtons',
  delimiters: ['{{{', '}}}'],
  data: {
    msg: 'hello',
  },
  methods: {
    onChange(e) {
      e.target.value === '2'
        ? ((this.$refs.vol.style.color = '#1E2D3A'), (this.$refs.org.style.color = '#92A0A3'))
        : ((this.$refs.org.style.color = '#1E2D3A'), (this.$refs.vol.style.color = '#92A0A3'));
    },
  },
});

new Vue({
  el: '#Quote',
  delimiters: ['{{{', '}}}'],
});
